import React from 'react';
import { Table } from 'antd';
import { DownOutlined, RightOutlined } from '@ant-design/icons';

import { useColumnSearch } from './columnSearch.jsx';

/** The arrow that opens a row. The row itself opens on a click too, so the arrow keeps its click to itself. */
const ExpandIcon = ({ expanded, onExpand, record }) => (
    <button
        type="button"
        className="uploads-expand"
        aria-expanded={expanded}
        aria-label={(expanded ? 'Hide' : 'Show') + ' the description of ' + record.message}
        onClick={(e) => {
            e.stopPropagation();
            onExpand(record, e);
        }}
    >
        {expanded ? <DownOutlined /> : <RightOutlined />}
    </button>
);

/**
 * The Error Log tab: every processing error with when it happened. A row
 * opens to its full description.
 *
 * @param {{ rows: { key, timestamp, sortKey, message, description }[], loading: boolean }} props
 */
const ErrorLog = ({ rows, loading }) => {
    const { textSearch, dateTimeRangeSearch } = useColumnSearch();

    const columns = [
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: 200,
            sorter: (a, b) => a.sortKey.localeCompare(b.sortKey),
            ...dateTimeRangeSearch('sortKey')
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message',
            className: 'uploads-error-message',
            ...textSearch('message', 'Message', { also: ['description'] })
        }
    ];

    return (
        <Table
            className="uploads-error-log"
            size="small"
            loading={loading}
            columns={columns}
            dataSource={rows}
            pagination={{ pageSize: 20, hideOnSinglePage: true }}
            scroll={{ x: 'max-content' }}
            locale={{ emptyText: 'No errors' }}
            expandable={{
                expandRowByClick: true,
                expandIcon: ExpandIcon,
                expandedRowRender: (row) => <p className="uploads-error-description">{row.description}</p>
            }}
        />
    );
};

export default ErrorLog;
